import * as toolsStorage from './storage';

export const getToken = () => {
  return toolsStorage.getItem('userToken');
};